module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "comp-reword-h-detail",
    attrs: {
      "visible": _vm.visible,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      }
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('div', {
    staticClass: "dialog-title flex flex-between"
  }, [_c('div', {
    staticClass: "lef flex"
  }, [_c('span', {
    staticClass: "reword-post"
  }, [_vm._v("岗位悬赏-" + _vm._s(_vm.postTitle))])]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-close close-btn",
    on: {
      "click": _vm.close
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "table-box"
  }, [_c('div', {
    staticClass: "table-tit flex"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("岗位悬赏历史明细")]), _vm._v(" "), _c('span', {
    staticClass: "total"
  }, [_vm._v(_vm._s(("共" + _vm.tableTotal + "条")))])]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "height": "400px",
      "overflow-y": "auto"
    },
    attrs: {
      "data": _vm.tableData
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "code",
      "label": "悬赏任务编号",
      "min-width": "265"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "typeCN",
      "label": "范围",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "singleAmount",
      "label": "单次佣金",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "updatedAt",
      "label": "浏览时间",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "startAt",
      "label": "上线时间",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "amount",
      "label": "预算设置",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "overspendCN",
      "label": "超支设置",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "count",
      "label": "累计派发数",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "expenseAmount",
      "label": "累计金额(元)",
      "width": "120"
    }
  })], 1), _vm._v(" "), (_vm.tableTotal > 0) ? _c('el-pagination', {
    staticClass: "flex flex-end",
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 20, 30],
      "page-size": _vm.pageSize,
      "layout": "sizes, prev, pager, next",
      "total": _vm.tableTotal
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      }
    }
  }) : _vm._e()], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-883ef828","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reword/HistoryDetail.vue
// module id = 900
// module chunks = 1